export default class TrackingServicePageVisitDispatch {
  constructor(baseUrl) {
    this.postUrl = baseUrl + "/page_visits";
  }

  send(args) {
    let xhttp = new XMLHttpRequest();
    xhttp.open('POST', this.postUrl, true);
    xhttp.setRequestHeader('Accept', 'application/json');
    xhttp.setRequestHeader('Content-Type', 'application/json');
    xhttp.withCredentials = true;
    xhttp.onreadystatechange = this.onSuccessCallback;

    xhttp.send(JSON.stringify({ page_visit: args }));
  }

  onSuccessCallback() {
    if (this.status == 200 && this.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
      window.BPFTracking.cookiesSet = true;
      window.dispatchEvent(new Event('bpfAnalyticsCookiesSet'));
    }
  }
}
